import { useEffect } from 'react';
import { useLocation } from 'react-router'

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top with smooth scroll behavior
    window.scrollTo({
      top: -100,
      behavior: 'smooth', // Enable smooth scroll
    });
  }, [location]); // This will run when the location (route) changes

  return null;
}

export default ScrollToTop;
